import { SESSION  as A } from 'actions/sessionActions';
import store from 'store';

var idler = 0;
export const 
sessionTimer = () => {
    return {
        run: function(time) {
            var minutes = time * 1000;
            time = time || 20;
            setInterval(function() {
                idler++;
                if(idler === time) endSession();
                else if(idler === (time - 1)) endSessionNotice();
            }, 60000);
        },
        restart: function() {
            updateSessionExpiration();
            idler = 0;
        }
    }
},
setSessionData = (action, payload) => {
    return {
        type: action,
        payload: payload
    }
},
toggleSessionExpiredModdal = () => ({ type: A.TOGGLE_SESSION_EXPIRED_MODAL });

function updateSessionExpiration() {
    store.dispatch({ type: A.SET_SESSION_CURRENT });
}

function endSession() {
    store.dispatch({ type: A.CLEAR_SESSION });
}

function endSessionNotice() {
    store.dispatch({
        type: A.SET_NOTICE,
        payload: 'pre-expiration-notice'
    });
}
